import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import React from "react";

export default function MobileMenuButton({ onClick, isOpen = false }) {
  return (
    <button className="inline-flex h-11 w-11 shrink-0 items-center justify-center" onClick={onClick} aria-label="Open menu" aria-expanded={isOpen}>
      <FontAwesomeIcon className="text-2xl" icon={faBars} />
    </button>
  );
}
